(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oh-header-model-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('oh-model-menu')) {
  customElements.define('oh-model-menu', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      if (!this.details || !this.summary) return;
      this.summary.setAttribute('aria-expanded', String(this.details.open));
      this.details.addEventListener('toggle', () => {
        this.summary.setAttribute('aria-expanded', String(this.details.open));
        if (this.details.open) document.querySelectorAll('oh-model-menu').forEach(menu => { if (menu !== this) menu.close(); });
      }, options);
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse' && window.matchMedia('(hover:hover) and (min-width:990px)').matches) {
          clearTimeout(this.closeTimer);
          this.openTimer = setTimeout(() => { this.details.open = true; }, 130);
        }
      }, options);
      this.addEventListener('pointerleave', () => {
        clearTimeout(this.openTimer);
        this.closeTimer = setTimeout(() => { if (!this.contains(document.activeElement)) this.close(); }, 220);
      }, options);
      this.addEventListener('focusout', () => {
        setTimeout(() => { if (!this.contains(document.activeElement)) this.close(); }, 0);
      }, options);
      document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) this.close(); }, options);
      this.addEventListener('keyup', event => {
        if (event.key === 'Escape' && this.details.open) { event.stopPropagation(); this.close(); this.summary.focus(); }
      }, options);
    }
    close() {
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
      if (this.details) this.details.open = false;
      if (this.summary) this.summary.setAttribute('aria-expanded', 'false');
    }
    disconnectedCallback() { this.close(); this.controller?.abort(); this.controller = null; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["oh-installments-link"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
    const link = event.target.closest('.oh-installments-link');
    if (!link) return;
    const scope = link.closest('product-info') || link.closest('.product__info-container');
    const variant = scope?.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
    const url = new URL(link.href, location.origin);
    if (variant) url.searchParams.set('variante', variant);
    link.href = url.href;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["oh-whatsapp-ficha"] && !Shopify.designMode) return;
  try {
    (() => {
    const intro = 'Hola, vengo de la web de Oh! Shop. ';
    const read = (root) => {
      if (!root.ohWaData) {
        try {
          root.ohWaData = JSON.parse(root.querySelector('[data-oh-wa-data]').textContent);
        } catch {
          root.ohWaData = null;
        }
      }
      return root.ohWaData;
    };
    const selectedOptions = (section) => {
      const picker = document.getElementById(`variant-radios-${section}`) || document.getElementById(`variant-selects-${section}`);
      if (!picker) return null;
      const fieldsets = picker.querySelectorAll('fieldset');
      if (fieldsets.length) return [...fieldsets].map((fs) => fs.querySelector('input:checked')?.value);
      return [...picker.querySelectorAll('select')].map((select) => select.value);
    };
    const update = (root) => {
      const data = read(root);
      if (!data) return;
      const section = root.dataset.section;
      const options = selectedOptions(section);
      let variant = null;
      if (options) {
        variant = data.variants.find((v) => v.options.length === options.length && v.options.every((o, i) => o === options[i]));
      } else {
        const id = document.querySelector(`#product-form-${section} [name="id"]`)?.value;
        variant = data.variants.find((v) => String(v.id) === String(id));
      }
      let item = data.product;
      if (variant?.label) item = item.endsWith(')') ? `${item.slice(0, -1)}, ${variant.label})` : `${item} (${variant.label})`;
      const tail = variant ? ` a S/ ${variant.price}. ${variant.url}` : `. ${data.url}`;
      const links = {
        ficha: { text: `${intro}Me interesa: ${item}${tail} [oh-ficha]`, label: `Consultar por WhatsApp sobre ${item}. Se abre en una pestaña nueva` },
        visita: { text: `${intro}Quiero verlo en la tienda: ${item}${tail} [oh-visita]`, label: `Quiero verlo en la tienda: escribir por WhatsApp sobre ${item}. Se abre en una pestaña nueva` },
      };
      root.querySelectorAll('[data-oh-wa]').forEach((link) => {
        const kind = links[link.dataset.ohWa];
        if (!kind) return;
        link.href = `https://wa.me/${data.phone}?text=${encodeURIComponent(kind.text)}`;
        link.setAttribute('aria-label', kind.label);
      });
    };
    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!target.closest) return;
      document.querySelectorAll('[data-oh-wa-ficha]').forEach((root) => {
        const s = root.dataset.section;
        if (target.closest(`#variant-radios-${s}, #variant-selects-${s}, #product-form-${s}`)) update(root);
      });
    });
    window.addEventListener('pageshow', () => document.querySelectorAll('[data-oh-wa-ficha]').forEach(update));
  })();
  } catch(e) { console.error(e); }
})();

})();
